import { render, staticRenderFns } from "./ModalCreateNewCrtieria.vue?vue&type=template&id=7b3ea658&"
import script from "./ModalCreateNewCrtieria.vue?vue&type=script&lang=js&"
export * from "./ModalCreateNewCrtieria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports